import { PaperClipOutlined, UploadOutlined } from '@ant-design/icons';
import { css } from '@emotion/react';
import { Button, Space, Typography } from 'antd';
import { useRef, useState } from 'react';
const { Title } = Typography;

type DownloadFileModalProps = {
    onCancel: () => void;
};

export const DownloadFileModal = ({
    onCancel,
}: DownloadFileModalProps) => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [fileName, setFileName] = useState<string | null>(null);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    const onEdit = () => {
        onCancel();
    }

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            setFileName(file.name);
            setSelectedFile(file);
        }
    };

    return (
        <div css={rootStyles}>
            <Title level={5}>Nhập nguyên liệu theo file</Title>
            <div css={uploadFileStyle}>
                <Button
                    css={fileStyle}
                    icon={<UploadOutlined />}
                    onClick={() => fileInputRef.current?.click()}
                >
                    Tải lên file excel
                    <input
                        id="file-upload"
                        type="file"
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                        ref={fileInputRef}
                    />
                </Button>
            </div>
            <div css={textFileStyle}>
                {selectedFile && (
                    <label>
                        <PaperClipOutlined />
                        <span className='colorTextFile'>{fileName}</span> 
                    </label>
                )}
            </div>
            <Space css={groupButtonStyles}>
                <Button type='primary' size='large' onClick={onEdit}>
                    Xác nhận 
                </Button>
            </Space>
        </div>
    );
};

const groupButtonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  margin-top: 1.6rem;
  margin-bottom: 0;
  button {
    padding: 2rem 4rem;
  }
`;

const rootStyles = css`
  background: var(--white-soft-color);
  display: flex;
  flex-direction: column;
  /* gap: 1.4rem; */
  min-height: calc(25vh - var(--header-height));
`;

const uploadFileStyle = css`
    display: flex;
    justify-content: start;
    width: 3rem;
`;

const textFileStyle = css`
    height: 3rem;
    margin-top: 1rem;
    .colorTextFile {
        margin-left: 0.5rem;
        color: var(--blue-light-color) !important;
    }
`

const fileStyle = css`
    display: flex;
    align-items: 'center';
    border-color: var(--blue-light-color) !important;
    color: var(--blue-light-color) !important;
`